import React from "react";
import { useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import IconInfoWithModalMain from "../../../components/IconInfoWithModal/IconInfoWithModal.Main";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  SYMBOL_CURRENCY,
  TEXT_CREATE_ORDER,
  TEXT_DRINKING_WATER,
  TEXT_ORDER_DES_1,
  TEXT_ORDER_DES_2,
  TEXT_ORDER_DES_3,
} from "../../../utils/useConstants";
import { FunctionGetPathUrl } from "../../../utils/useFunction";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_3_REGULAR,
  STYLE_FLEX,
  STYLE_HEADING_2,
  STYLE_HOVER_BLUE,
  STYLE_ICON_INFO_HOME,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
  STYLE_TITLE_ADDON,
  STYLE_UNDERLINE_BLUE_24_16,
} from "../../../utils/useStyle";

const WaterCard = ({ size, des, prize, des_mb, des_mb_2, icon }) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div className={` md:w-addon_select mx-auto flex gap-2.5 `}>
      <img src={icon} className=" w-w_53 h-h_53" />
      <div className=" flex justify-between w-full ">
        <div className="">
          <div className={`${STYLE_TITLE_ADDON(language)}`}>{size}</div>
          <div
            className={`${
              language === "TH" ? " text-sm-th " : " text-sm "
            } text-laundry-gray-80  font-normal w-full  `}
          >
            {isMobile ? (
              <div className="">
                {des_mb}
                <div className="text-laundry-gray-100">{des_mb_2}</div>
              </div>
            ) : (
              <div className="text-laundry-gray-100"> {des}</div>
            )}
            {/* {des} */}
          </div>
        </div>
        <div
          className={`${
            language === "TH"
              ? " text-sm-th md:text-base-th "
              : " text-sm md:text-base "
          } text-laundry-gray-100 font-semibold `}
        >
          +<span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
          {prize}
        </div>
      </div>
    </div>
  );
};

const PricingWater = ({ config, name, description, price, water }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className=" bg-laundry-bglight w-full h-full py-10 px-4  ">
      <IconInfoWithModalMain
        classNameIcon={`${STYLE_ICON_INFO_HOME} ${STYLE_HOVER_BLUE} `}
        description={config?.water_description}
        description2={config?.water_description_2}
        image={config?.water_image_key_desktop}
        modalItitle={config?.water_title}
        classNameWrapper={`${STYLE_HEADING_2(
          language
        )} ${STYLE_FLEX} justify-center`}
        title={<React.Fragment>{TEXT_DRINKING_WATER[language]}</React.Fragment>}
      />
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={`${STYLE_BODY_3_REGULAR(
          language
        )} text-center pb-6 md:pb-6.5 ${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP} `}
      >
        {language === "TH" && (
          <div className="">
            ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา
            คุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน
            {isMobile ? (
              <span>เวลาเราไปส่งคืนออเดอร์ของคุณ</span>
            ) : (
              <div>เวลาเราไปส่งคืนออเดอร์ของคุณ</div>
            )}
          </div>
        )}
        {language === "EN" && (
          <div>
            {TEXT_ORDER_DES_2[language]}
            {isMobile ? (
              <span>
                when we return
                <span> your order.</span>
              </span>
            ) : (
              <span>{TEXT_ORDER_DES_3[language]}</span>
            )}
          </div>
        )}
      </div>

      <div className=" space-y-6">
        {water
          ?.filter((i) => {
            return i.price;
          })
          ?.sort((a, b) => {
            const aKey = a?._id;
            const bKey = b?._id;
            return (
              [
                "6314264c7a1baccc80de71b5",
                "6314264c7a1baccc80de71c6",
                "6314264c7a1baccc80de71b6",
              ].indexOf(aKey) -
              [
                "6314264c7a1baccc80de71b5",
                "6314264c7a1baccc80de71c6",
                "6314264c7a1baccc80de71b6",
              ].indexOf(bKey)
            );
          })
          ?.map((row) => {
            return (
              <WaterCard
                icon={FunctionGetPathUrl(row?.icon_key)}
                size={row?.name}
                des={row?.description}
                prize={row?.price}
                des_mb={row?.description?.slice(
                  0,
                  row?.description?.split("").findIndex((i) => {
                    return i === "(";
                  })
                )}
                des_mb_2={`(${row?.description?.substring(
                  row?.description?.indexOf("(") + 1,
                  row?.description?.indexOf(")")
                )})`}
              />
            );
          })}
      </div>

      <div className=" mt-6.5 md:w-button mx-auto">
        <BlueButton
          className={`${
            language === "TH" ? " text-base-th " : " text-base "
          } w-full bg-laundry-primary-blue hover: p-4 md:p-3 xl:p-4 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue hover:bg-laundry-gray-80 focus:outline-none h-[60px] md:h-input `}
          title={TEXT_CREATE_ORDER[language]}
          onClick={() => {
            navigate("/OurServices");
          }}
        />
      </div>
    </div>
  );
};

export default PricingWater;
